import { render } from "./NewExpense.vue?vue&type=template&id=4bce016b"
import script from "./NewExpense.vue?vue&type=script&lang=js"
export * from "./NewExpense.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__